import React from 'react';
import Grid from "@mui/material/Grid";
import {Avatar, Chip, TextField} from "@mui/material";
import moment from "moment";
import { Autocomplete } from '@mui/material';
import {amber, blue, brown, green, orange, red} from "@mui/material/colors";
import FaceTwoToneIcon from "@mui/icons-material/FaceTwoTone";
import VerifiedUserTwoToneIcon from "@mui/icons-material/VerifiedUserTwoTone";
import AddTwoToneIcon from "@mui/icons-material/AddTwoTone";
import RemoveTwoToneIcon from "@mui/icons-material/RemoveTwoTone";
import HelpOutlineTwoToneIcon from "@mui/icons-material/HelpOutlineTwoTone";
import {PaperComponent} from "../../../../../styles/components/DynamicComponentStyle";

const TamponeDetailsStep = ({tampone, tags, setTags, showTag = true}) => {

	const handleCreateTag = event => {
		switch (event.key) {
			case ",":
			case "\n":
			case "\t":
			case " ": {
				event.preventDefault();
				event.stopPropagation();
				if (event.target.value.length > 0) {
					setTags([...tags, "#" + event.target.value?.toUpperCase()]);
				}
				break;
			}
			default:
		}
	};

	return (
        <React.Fragment>
            <Grid container spacing={3}>
				<Grid item xs={12}>
					<TextField
						label="Codice fiscale"
						defaultValue={tampone?.codF}
						InputProps={{
							readOnly: true,
						}}
						fullWidth={true}
						variant="outlined"
					/>
				</Grid>
				<Grid item xs={12} sm={4}>
					<TextField
						label="Tipo tampone"
						defaultValue={tampone?.testTipoDesc}
						InputProps={{
							readOnly: true,
						}}
						fullWidth={true}
						variant="outlined"
					/>
				</Grid>
				<Grid item xs={12} sm={4}>
					<TextField
						label="Esito tampone"
						defaultValue={tampone?.esitoTampone}
						InputProps={{
							readOnly: true,
						}}
						fullWidth={true}
						variant="outlined"
					/>
				</Grid>
				<Grid item xs={12} sm={4}>
					<TextField
						label="Data esito"
						defaultValue={tampone.dataEsito ? moment(tampone.dataEsito).format("DD/MM/YYYY") : ""}
						InputProps={{
							readOnly: true,
						}}
						fullWidth={true}
						variant="outlined"
					/>
				</Grid>
				<Grid item xs={12} sm={6}>
					<TextField
						label="Data prelievo prevista"
						defaultValue={tampone.dataPrelievoPrevista ? moment(tampone.dataPrelievoPrevista).format("DD/MM/YYYY") : ""}
						InputProps={{
							readOnly: true,
						}}
						fullWidth={true}
						variant="outlined"
					/>
				</Grid>
				<Grid item xs={12} sm={6}>
					<TextField
						label="Data prelievo effettiva"
						defaultValue={tampone.dataPrelievoEffettiva ? moment(tampone.dataPrelievoEffettiva).format("DD/MM/YYYY") : ""}
						InputProps={{
							readOnly: true,
						}}
						fullWidth={true}
						variant="outlined"
					/>
				</Grid>
				<Grid item xs={12} sm={8}>
					<TextField
						label="Laboratorio"
						defaultValue={tampone?.laboratorio}
						InputProps={{
							readOnly: true,
						}}
						fullWidth={true}
						variant="outlined"
					/>
				</Grid>
				<Grid item xs={12} sm={4}>
					<TextField
						label="Data assegnazione"
						defaultValue={tampone.dataAssegnazione ? moment(tampone.dataAssegnazione).format("DD/MM/YYYY") : ""}
						InputProps={{
							readOnly: true,
						}}
						fullWidth={true}
						variant="outlined"
					/>
				</Grid>
				<Grid item xs={12} sm={4}>
					<TextField
						label="Medico richiedente"
						defaultValue={tampone?.medicoRichiedente}
						InputProps={{
							readOnly: true,
						}}
						fullWidth={true}
						variant="outlined"
					/>
				</Grid>
				<Grid item xs={12} sm={8}>
					<TextField
						label="Contatto richiedente"
						defaultValue={tampone?.contattoRichiedente}
						InputProps={{
							readOnly: true,
						}}
						fullWidth={true}
						variant="outlined"
					/>
				</Grid>
				<Grid item xs={12} sm={6}>
					<TextField
						label="Criterio epidemiologico"
						defaultValue={tampone?.criterioEpidemiologico}
						InputProps={{
							readOnly: true,
						}}
						multiline={true}
						rows={3}
						fullWidth={true}
						variant="outlined"
					/>
				</Grid>
				<Grid item xs={12} sm={6}>
					<TextField
						label="Motivazione"
						defaultValue={tampone?.motivazione}
						InputProps={{
							readOnly: true,
						}}
						multiline={true}
						rows={3}
						fullWidth={true}
						variant="outlined"
					/>
				</Grid>
				<Grid item xs={12}>
					<TextField
						label="Descrizione tipo soggetto"
						defaultValue={tampone?.descTipoSoggetto}
						InputProps={{
							readOnly: true,
						}}
						multiline={true}
						rows={2}
						fullWidth={true}
						variant="outlined"
					/>
				</Grid>
				<Grid item xs={12}>
					{
						tampone?.descTipoSoggetto &&
						<Chip label={tampone.descTipoSoggetto.toUpperCase()}
						      avatar={<Avatar style={{backgroundColor: amber[700]}}><FaceTwoToneIcon
							      style={{color: "#000"}}/></Avatar>} style={{
							marginRight: 8,
							marginTop: 8,
							backgroundColor: amber[500],
							color: "#000"
						}}/>
					}
					{
						tampone?.tamponeAutorizzato &&
						<Chip label={"TAMPONE AUTORIZZATO"}
						      avatar={<Avatar style={{backgroundColor: blue[700]}}><VerifiedUserTwoToneIcon
							      style={{color: "#000"}}/></Avatar>} style={{
							marginRight: 8,
							marginTop: 8,
							backgroundColor: blue[500],
							color: "#000"
						}}/>
					}
					{
						tampone?.esitoTampone === "POSITIVO" &&
						<Chip label={"POSITIVO"}
						      avatar={<Avatar style={{backgroundColor: red[700]}}><AddTwoToneIcon
							      style={{color: "#000"}}/></Avatar>} style={{
							marginRight: 8,
							marginTop: 8,
							backgroundColor: red[500],
							color: "#000"
						}}/>
					}
					{
						tampone?.esitoTampone === "NEGATIVO" &&
						<Chip label={"NEGATIVO"}
						      avatar={<Avatar style={{backgroundColor: green[700]}}><RemoveTwoToneIcon
							      style={{color: "#000"}}/></Avatar>} style={{
							marginRight: 8,
							marginTop: 8,
							backgroundColor: green[500],
							color: "#000"
						}}/>
					}
					{
						tampone?.esitoTampone !== "NEGATIVO" && tampone.esitoTampone !== "POSITIVO" &&
						<Chip label={tampone.esitoTampone === "N/D" ? "NON DICHIARATO" : tampone.esitoTampone}
						      avatar={<Avatar style={{backgroundColor: orange[700]}}><HelpOutlineTwoToneIcon
							      style={{color: "#000"}}/></Avatar>} style={{
							marginRight: 8,
							marginTop: 8,
							backgroundColor: orange[500],
							color: "#000"
						}}/>
					}
					{
						tampone?.criterioEpidemiologico?.includes("stretto") &&
						<Chip label={"CONTATTO STRETTO"}
						      avatar={<Avatar style={{backgroundColor: green[700], color: "#FFF"}}>#</Avatar>} style={{
							marginRight: 8,
							marginTop: 8,
							backgroundColor: green[500],
							color: "#000"
						}}/>
					}
					{
						tampone?.criterioEpidemiologico?.includes("asintomatico") &&
						<Chip label={"ASINTOMATICO"}
						      avatar={<Avatar style={{backgroundColor: brown[700], color: "#FFF"}}>#</Avatar>} style={{
							marginRight: 8,
							marginTop: 8,
							backgroundColor: brown[500],
							color: "#FFF"
						}}/>
					}
					{
						tampone?.criterioEpidemiologico?.includes("Sintomatico") && !tampone.criterioEpidemiologico?.includes("asintomatico") &&
						<Chip label={"SINTOMATICO"}
						      avatar={<Avatar style={{backgroundColor: red[700], color: "#FFF"}}>#</Avatar>} style={{
							marginRight: 8,
							marginTop: 8,
							backgroundColor: red[500],
							color: "#000"
						}}/>
					}
					{
						tampone.note && tampone.note.match(/#(\S*)/g)?.map(item => {
							return (
								<Chip
									key={item}
									label={item.substring(1)}
									avatar={<Avatar><b>#</b></Avatar>}
									color={"secondary"}
									style={{
										marginRight: 8,
										marginTop: 8,
									}}/>
							)
						})
					}
				</Grid>
				{showTag && <Grid item xs={12}>
					<Autocomplete
						multiple
						freeSolo
						options={[]}
						PaperComponent={PaperComponent}
						getOptionLabel={option => option || option}
						value={tags}
						onChange={(event, newValue) => setTags(newValue)}
						filterSelectedOptions
						renderInput={params => {
							params.inputProps.onKeyDown = handleCreateTag;
							return (
								<TextField
									{...params}
									variant="outlined"
									label="TAG del tampone"
									fullWidth
								/>
							);
						}}
					/>
				</Grid>}
			</Grid>
        </React.Fragment>
    );
}

export default React.memo(TamponeDetailsStep)
